module.exports = __webpack_public_path__ + "static/media/im.6c0aa540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/im.png
// module id = 1882
// module chunks = 0